import dataBase from '@/dataBase/database'
import { motivationalReportService } from './motivationalReport.service'
import { config } from '@/_helpers'

export const offlineMotivationalReportService = {

  //получение мотивационного отчёта
  async getMotivationalReport(projectId, networkId, pointId) {
    if(navigator.onLine) {
      try {
        let data = await motivationalReportService.loadMyMotivation(projectId, networkId, pointId)
        if (data) {
          await dataBase.motivationalReport.put({
            id:           String(data.id),
            projectId:    String(projectId),
            pointId:      String(pointId),
            createdAt:    data.createDate,
            cachedAt:     new Date().toISOString(),
          })

        if(data.motivationalDmp && data.motivationalDmp.length) {
          this.loadMotivationalDmp(data.motivationalDmp, data.id)
        }
          return data
        }
      } catch (e) {
        console.log(e);
        console.warn('[offlineMotivationalReportService] getMotivationalReport: нет ответа, берём кэш')
      }
      
    }

    let motivationalReport = await dataBase.motivationalReport.where('pointId').equals(String(pointId)).first()
    if (!motivationalReport) return null
    let motivationalDmp = await dataBase.motivationalDmp.where('motivationalReportId').equals(Number(motivationalReport.id)).toArray()
    if(motivationalDmp && motivationalDmp.length) {
      motivationalReport.motivationalDmp = motivationalDmp
    }
    return motivationalReport
  },

  //подгрузка дмп
  async loadMotivationalDmp(motivationalDmp, motivationalReportId) {
    for (let dmp of motivationalDmp) {
      try {
        let existing = await dataBase.motivationalDmp.where('serverId').equals(dmp.id).first()

        if (existing) {
          await dataBase.motivationalDmp.update(existing.id, {
            dmpCategory:          dmp.dmpCategory,
            comment:              dmp.comment,
            motivationalReportId: Number(motivationalReportId),
            serverId:             dmp.id,
            synced:               1,
            cachedAt:             new Date().toISOString(),
          })
        } else {
          await dataBase.motivationalDmp.add({
            dmpCategory:          dmp.dmpCategory,
            comment:              dmp.comment,
            motivationalReportId: Number(motivationalReportId),
            serverId:             dmp.id,
            synced:               1,
            createdAt:            new Date().toISOString(),
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  
  //получение dmp категорий
  async loadCategories() {
    if(navigator.onLine) {
      try {
        let data = await motivationalReportService.loadDmpCategories()
        await dataBase.dmpCategories.clear()
        await dataBase.dmpCategories.bulkPut(
          data.map(c => ({ ...c,
            title: c.title, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.log(e);
        console.warn('[motivationalReportService] loadCategories: нет ответа, берём кэш')
      }
    }
    return dataBase.dmpCategories.toArray()
  },

  //создание dmp 
  async createDmp(motivationalDmp, motivationalReportId) {
    if(navigator.onLine) {
      return await motivationalReportService.createDmp(motivationalDmp, motivationalReportId)
    }

    let motivationalReport = await dataBase.motivationalDmp.add({
      dmpCategory: motivationalDmp.dmpCategory,
      comment: motivationalDmp.comment,
      motivationalReportId: Number(motivationalReportId),
      serverId: 0,
      synced: 0,
      cachedAt: new Date().toISOString() 
    })
    return dataBase.motivationalDmp.get(motivationalReport);
  },

  //загрузка формы отчета
  async loadReportForm(dmpId) {
    if(navigator.onLine) {
      try {
        let data = await motivationalReportService.loadDmpReport(dmpId)
        let localDmp = await dataBase.motivationalDmp.where('serverId').equals(Number(dmpId)).first()
        await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(localDmp.id)).delete()
        await dataBase.motivationalDmpReport.add({
          localDmpId: Number(localDmp.id),
          dmpCategory: data.dmpCategory,
          synced: 1,
          cachedAt: new Date().toISOString()
        })

        if(data.reportPhotos && data.reportPhotos.length) {
          await dataBase.photos.where('reportId').equals(`${localDmp.motivationalReportId}_${localDmp.id}`).delete()
          for (const photo of data.reportPhotos) {
            const response = await fetch(config.image(photo.uuid))
            const blob = await response.blob()
            await dataBase.photos.add({
              reportId: `${localDmp.motivationalReportId}_${localDmp.id}`,
              uuid: photo.uuid,
              extension:  photo.extension,
              blob: blob,
              synced: 1,
              dmp: photo.dmp,
              motivational: photo.motivational,
              createdAt:  new Date().toISOString(),
            })
          }
        } else {
          await dataBase.photos.where('reportId').equals(`${localDmp.motivationalReportId}_${localDmp.id}`).delete()
        }
        return data
      } catch (error) {
        console.log(error);
        throw error;
      }
    }

    const existing = await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmpId)).first()
    let reportId
    const dmp = await dataBase.motivationalDmp.get(dmpId)
    if(existing) {
      reportId = existing.id
    } else {
      reportId = await dataBase.motivationalDmpReport.add({
        localDmpId: Number(dmpId),
        dmpCategory: dmp.dmpCategory,
        synced: null,
        cachedAt: new Date().toISOString()
      })
    }
    let cached = await dataBase.motivationalDmpReport.get(reportId)
    const photos = await dataBase.photos.where('reportId').equals(`${dmp.motivationalReportId}_${dmpId}`).toArray()
    cached.reportPhotos = []
    if(photos.length) {
      for (const photo of photos) {
        cached.reportPhotos.push(photo)
      }
    }
    return cached
  },

  //создание мотивационного отчета
  async saveDmpReport(dmpId, report) {
    if(navigator.onLine) {
      return motivationalReportService.sendReportDmp(dmpId, report)
    }
    const dmp = await dataBase.motivationalDmp.get(dmpId)
    for (let photo of (report.reportPhoto || [])) {
      if (photo.isOffline && photo.blob) {
        await dataBase.photos.add({
          reportId: `${dmp.motivationalReportId}_${dmpId}`,
          blob: photo.blob,
          motivational: photo.motivational,
          dmp: photo.dmp || false,
          fileName: photo.name,
          synced: 0,
          createdAt: new Date().toISOString(),
        })
      }
    }
    const existing = await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmpId)).first()
    let reportId

    if(existing) {
      await dataBase.motivationalDmpReport.update(existing.id, {
        dmpCategory: report.dmpCategory,
        synced: 0,
        cachedAt: new Date().toISOString()
      })
      reportId = existing.id
    } else {
      reportId = await dataBase.motivationalDmpReport.add({
        localDmpId: Number(dmpId),
        dmpCategory: report.dmpCategory,
        synced: 0,
        cachedAt: new Date().toISOString()
      })
    }

    return dataBase.motivationalDmpReport.get(reportId)
  },
  

}